import { render, staticRenderFns } from "./iconButton.vue?vue&type=template&id=4b32c3e4&scoped=true&"
import script from "./iconButton.vue?vue&type=script&lang=js&"
export * from "./iconButton.vue?vue&type=script&lang=js&"
import style0 from "./iconButton.vue?vue&type=style&index=0&id=4b32c3e4&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b32c3e4",
  null
  
)

export default component.exports